import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ts-page-header',
  templateUrl: './ts-page-header.component.html',
  styleUrls: ['./ts-page-header.component.scss'],
})
export class TsPageHeaderComponent implements OnInit {
  @Input() displaySeparationBorder = false;

  constructor() {}

  ngOnInit() {}
}
